import { render, staticRenderFns } from "./HotIcon.vue?vue&type=template&id=bb8ff0cc&scoped=true&"
import script from "./HotIcon.vue?vue&type=script&lang=js&"
export * from "./HotIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8ff0cc",
  null
  
)

export default component.exports